export default __webpack_public_path__ + "static/media/blue.639f6efe.svg";